import type { ResultOf } from '@graphql-typed-document-node/core';

import Box from '@mui/material/Box';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { NoData } from '../../../components/Illustrations/NoData';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { DataGrid } from '../../../components/DataGrid';

import { getColumns } from './get-columns';

export const UsersPage_List_User_Fragment = graphql(`
  fragment UsersPage_List_User_Fragment on User {
    _id
    email
    person {
      civilityId
      activeMemberships {
        organization {
          _id
          identifier {
            kind
            value
          }
          color
          name
          tradingName
        }
        functions
        contextualRoleIds
        representativeTypeIds
      }
      color
      firstName
      lastName
      birthDate
    }
    lastSeenAt
    statusId
  }
`);

export type UsersPage_List_User = ResultOf<typeof UsersPage_List_User_Fragment>;

interface Props {
  readonly users: readonly FragmentType<typeof UsersPage_List_User_Fragment>[];
}

export const List = ({ users: pUsers }: Readonly<Props>) => {
  const users = getFragmentData(UsersPage_List_User_Fragment, pUsers);

  const { civilities } = useReferencesContext();

  return !users.length ? (
    <NoData />
  ) : (
    <Box sx={{ flexGrow: 1, width: '100%', pt: 2 }}>
      <DataGrid columns={getColumns(civilities)} rows={users} />
    </Box>
  );
};
